import { POINTER_CLASSES, ANNOTATION_COLORS } from "../../config/config";
import Annotation from "./annotation";
import { defaultTransform } from "../geometry";

export default class InteractiveAnnotation extends Annotation {
  constructor(position, options) {
    super();

    this.interactionX = 0;
    this.interactionY = 0;

    this.originalPosition = { x: position && position.x, y: position && position.y };
    this.textSize = options && options.textSize || 40;
    this.lineWidth = options && options.lineWidth || 5;
    this.color = options && options.color || ANNOTATION_COLORS.White;
    this.scale = options && options.scale || 1;
    this.transform = options && options.transform || defaultTransform();

    this.isContinuous = false;
    this.font = this.options.textSize + "px Calibri";
  }

  draw() { }

  isInBounds() { return false; }
  
  mousedown(x, y) {
    this.interactionX = x;
    this.interactionY = y;
  }

  mouseup() { }

  mousemove() { }

  deactivate() { }

  keypress() { }

  // note - return false to assert that this annotation should not be deleted completely
  // this is appropriate if an annotation has special delete behavior
  delete() { return true; }


  getHoverClass() {
    return POINTER_CLASSES.pointer;
  }

  getActiveClass(x, y) {
    return this.getHoverClass(x, y);
  }

  getAndUpdateInteraction(x, y) {
    const dx = x - this.interactionX;
    const dy = y - this.interactionY;
    this.interactionX = x;
    this.interactionY = y;
    return { dx, dy };
  }

  setParentTransform(transform) {
    this.transform = transform;
  }

  updateTextSize(size) {
    this.setTextSize(size);
    this.font = this.options.textSize + "px Calibri";
  }

  updateColor(color) 
  {
    this.color = color;
  }
}